import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export const timeAgo = (iso) => {
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 3600) return `${Math.max(1, Math.floor(s / 60))}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const NewsCard = ({ item, index = 0 }) => (
  <Link
    to={`/news/${item.slug}`}
    data-testid={`news-card-${item.slug}`}
    className="group block rounded-xl border border-white/10 bg-white/[0.02] p-5 hover:border-primary/50 hover:bg-primary/[0.04] transition-colors animate-in fade-in slide-in-from-bottom-2"
    style={{ animationDelay: `${Math.min(index, 12) * 40}ms`, animationFillMode: "both" }}
  >
    {item.image && (
      <div className="mb-4 aspect-video overflow-hidden rounded-lg bg-black">
        <img src={item.image} alt={item.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />
      </div>
    )}
    <div className="flex flex-wrap items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-muted-foreground">
      <span className="text-primary">{item.category_label}</span>
      <span>•</span>
      <span className="truncate max-w-[10rem]">{item.source}</span>
      <span>•</span>
      <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" />{timeAgo(item.published_at)}</span>
    </div>
    <h3 className="mt-3 font-semibold leading-snug text-white group-hover:text-primary transition-colors">{item.title}</h3>
    {item.summary && <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{item.summary}</p>}
  </Link>
);
